module.exports = __webpack_public_path__ + "static/media/arrow-black.e4541d40.svg";